import { Button, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import Link from 'next/link';

export const SettingBox = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '52px',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(1),
  background: theme.palette.bg.secondary,
  border: theme.palette.border.normal,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const SettingBoxLeft = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  gap: theme.spacing(1),
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '1px',
    height: '35px',
    background: theme.palette.grey['100'],
    opacity: 0.12,
    right: 0,
    marginRight: `-${theme.spacing(3)}`,
  },
}));
export const SettingBoxCenter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const SettingBoxRight = styled('div')(({ theme }) => ({
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Readex Pro',
  fontWeight: 500,
  color: theme.palette.grey['50'],
}));

export const StyledBtn = styled(Button)(({ theme }) => ({}));

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  // color: theme.palette.primary.contrastText,
  // '&.Mui-checked': {
  //   color: theme.palette.primary.contrastText,
  // },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  width: '84px',
  height: '32px',
  lineHeight: '32px',
  borderRadius: '8px',
  textAlign: 'center',
  fontSize: '13px',
  color: theme.palette.secondary.dark,
  border: `1px solid ${theme.palette.secondary.dark}`,
  transition: 'color 0.3s ease',
  '&:hover': {
    color: theme.palette.text.white,
  },
}));
